import { Prisma } from "@prisma/client";
import { EventDetails, eventDetailsTypeValues } from "./events.types";
import { AssertAssignable } from "./utils.types";

export const eventDetailsForViewTimetableTypeValues =
  Prisma.validator<Prisma.EventTimetableDefaultArgs>()({
    select: {
      id: true,
      day: true,
      state: true,
      openingTime: true,
      closingTime: true,
      breakStartTime: true,
      breakEndTime: true,
    },
  });

export const eventDetailsForViewAddressTypeValues =
  Prisma.validator<Prisma.AddressDefaultArgs>()({
    select: {
      address: true,
      lat: true,
      long: true,
      zipCode: true,
      city: true,
    },
  });

export const eventDetailsForViewTypeValues =
  Prisma.validator<Prisma.EventDefaultArgs>()({
    select: {
      id: true,
      name: true,
      description: true,
      isIndoor: true,
      isOutdoor: true,
      isPaidEntry: true,
      organiserEmail: true,
      organiserPhone: true,
      isProgramOnline: true,
      eventEntrances: {
        select: {
          address: eventDetailsForViewAddressTypeValues,
        },
      },
      socials: {
        select: {
          websiteUrl: true,
          facebookUrl: true,
          twitterUrl: true,
          instagramUrl: true,
          youtubeUrl: true,
          linkedinUrl: true,
        },
      },
      address: eventDetailsForViewAddressTypeValues,
      dates: {
        select: {
          schedules: {
            select: {
              fromDate: true,
              toDate: true,
              id: true,
              eventDateId: true,
              timetables: eventDetailsForViewTimetableTypeValues,
            },
          },
          exceptionalClosingDates: {
            select: {
              date: true,
              id: true,
              eventDateId: true,
            },
          },
          isContinuous: true,
        },
      },
      organiser: {
        select: {
          adminId: true,
          admin: {
            select: {
              id: true,
              firstName: true,
              lastName: true,
              email: true,
              phoneNumber: true,
            },
          },
        },
      },
      customEventAppearance: {
        select: {
          countdown: true,
          eventInfoSections: true,
        },
      },
      activities: {
        select: {
          schedules: {},
        },
      },
      eventStructures: eventDetailsTypeValues.include.eventStructures,
      ticketing: true,
    },
  });

export type EventDetailsForView = Prisma.EventGetPayload<
  typeof eventDetailsForViewTypeValues
>;

type ConfirmEventForPreviewImplementsEventDetailsForView = AssertAssignable<
  EventDetailsForView,
  EventDetails
>;
